import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import fieldsDictionary from "../fieldsDictionary";
import { FieldViewType } from "../viewType";
import { fieldsType } from "@/utils/types/field";
import NameFieldDetail from "./detail";
import NameFieldEdit from "./edit";
import NameFieldList from "./list";
/** <b>Composant qui contient l'affichage d'un champ de type name en: </b>
 *  <li>Liste</li>
 *  <li>Détails</li>
 *  <li>Édition</li>
 */
export function Name() {
    return _jsx(_Fragment, { children: "Name" });
}
var field = fieldsType.name;
fieldsDictionary.registerField(FieldViewType.DETAIL, field, NameFieldDetail);
fieldsDictionary.registerField(FieldViewType.EDIT, field, NameFieldEdit);
fieldsDictionary.registerField(FieldViewType.LIST, field, NameFieldList);
